export const CookieName = {
  ACCESS_TOKEN: 'access-token',
  REFRESH_TOKEN: 'refresh-token'
}

export const CookieMaxAge = {
  [CookieName.REFRESH_TOKEN]: 30 * 24 * 60 * 60
}
